import {appIntl} from '@crema/utility/helper/Utils';
import jwtAxios from '@crema/services/auth/jwt-auth';
import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
} from 'shared/constants/ActionTypes';
import {API} from 'shared/constants/AppEnums';

const controller = new AbortController();
class Item {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
}

function replacer(key, value) {
  const rewrite = 'children';
  // If the value at this depth is an object (but not an iterable
  // like array or Set or Map), then rebind the properties you
  // need rebound, provided they exist:
  if (value){
    if (typeof value === `object` && !value[Symbol.iterator]) {
      if (value[rewrite]) {
        // By editing "value", we're directly updating "data".
        value.nodes = value[rewrite];
        delete value[rewrite];
      }
    }
    return value;
  } 
}

function removeSubDivisiNodes(data) {
    return data
        .filter(node => !node.title.includes("SUB DIVISI"))
        .map(node => {
            if (Array.isArray(node.nodes)) {
                node.nodes = removeSubDivisiNodes(node.nodes);
            }
            return node;
        });
  }

class ItemCollections {
  currentIndex = 0;
  items = [];

  constructor(maxItems = 10) {
    this.maxItems = maxItems;
  }

  addItem(key, value) {
    this.items[this.currentIndex] = new Item(key, value);
    this.currentIndex += 1;
    if (this.currentIndex > this.maxItems - 1) {
      this.currentIndex = 0;
    }
    console.log('items after add', this.items);
  }

  checkItemExists(key) {
    return this.items.findIndex((item) => {
      return item.key == key;
    });
  }

  getItemValue(index) {
    return this.items[index].value;
  }
}

export function useGetItem(
  itemCollections,
  keyUrl,
  actionType,
  isTree = false,
  save = true,
  useReplacer = false,
  useCRSFE = false,
  hideSubDivLpmukp = false
) {
  const {messages} = appIntl();
  let data;
  return (dispatch) => {
    let i = itemCollections.checkItemExists(keyUrl);
    if (i > -1) {
      data = itemCollections.getItemValue(i);
      if(hideSubDivLpmukp) data = removeSubDivisiNodes(data);
      dispatch({
        type: actionType,
        payload: {
          detail: data,
        },
      });
    } else {
      // controller.abort();
      dispatch({type: FETCH_START});
      let config = {...API.requestOptionsGET(), signal: controller.signal};
      console.log(keyUrl)
      jwtAxios.get(keyUrl, config).then((data) => {
        if (data.status === 200) {
          console.log(data);
          let tmp;
          if (useCRSFE){
            tmp = data.data.results.result;
          }else{
            tmp = data.data.results;
          }
          if(hideSubDivLpmukp){
            tmp = removeSubDivisiNodes(tmp);
          }
          if (isTree) {
            if (!useReplacer){
              JSON.stringify(tmp);
            }else{
              // JSON.stringify(tmp,replacer);
              JSON.stringify(tmp);
            }
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: actionType,
            payload: {
              detail: tmp,
            },
          });
          if (save) itemCollections.addItem(keyUrl, tmp);
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: messages['message.somethingWentWrong'],
          });
        }
      });
    }
  };
}

export default ItemCollections;
